import { ArrowUpRight } from "lucide-react"

export function MetricsCard({ title, value, change, chart }) {
  return (
    <div className="p-4 rounded-lg shadow-md" style={{ borderLeft: "4px solid #D4AF37", backgroundColor: "#F5F5DC" }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium" style={{ color: "#1A365D" }}>
          {title}
        </h3>
        {chart ? <ArrowUpRight className="h-4 w-4 text-muted-foreground" /> : null}
      </div>
      <div className="flex items-end justify-between">
        <div>
          <p className="text-2xl font-bold" style={{ color: "#1A365D" }}>
            {value}
          </p>
          <div className="flex items-center gap-1 mt-1">
            <span className="text-sm">+{change.value}</span>
            <span className={`text-sm ${change.isPositive ? "text-green-500" : "text-red-500"}`}>
              {change.percentage}
            </span>
          </div>
        </div>
        {chart}
      </div>
    </div>
  )
}

